import { setFiles } from '../features/files/filesSlice';

export const removeFile = (id) => {
  return (dispatch, getState) => {
    const { files } = getState();
    const { files: filesCurrent } = files;
    dispatch(setFiles(filesCurrent.filter((item) => item.id !== id)));
  };
};
